import { DefaultContext } from '@apollo/client'
import * as React from 'react'

import { useAuthCtx } from '~logic/auth/AuthProvider'
import { getBaseHttpHeaders } from '~logic/graphQL/httpHeaders'

import { useLocaleCtx } from '../../../config/contexts/LocaleProvider'

/**
 * Returns operation context for customer-accounts GQL operations,
 *
 * uses the `userToken` of the currently logged in customer/guest,
 * ignores the token from url.
 */
export const useCustomerOperationContext = () => {
  const locale = useLocaleCtx()
  const { userToken } = useAuthCtx()

  const context = React.useMemo<DefaultContext | undefined>(() => {
    if (!userToken) return

    return {
      headers: getBaseHttpHeaders({ locale, authToken: userToken }),
    }
  }, [locale, userToken])

  return context
}
